var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEcoforBtpack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 355.95 65.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;stroke:#fc0;}.cls-1{stroke-width:1.5px;}.cls-2{fill:#fc0;}.cls-3{stroke-width:2px;}.cls-4{fill:#256cb4;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_6",
    "data-name": "Capa 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    className: "cls-1",
    d: "M216.94,17.43h9.83c5.77,0,10.34,1.44,10.34,6.87a6.08,6.08,0,0,1-4.65,5.94v.17c3.91.77,5.86,2.79,5.86,6.45,0,5.7-4.74,8.15-10.69,8.15H216.94Zm9.67,10.86c2.38,0,3.4-1.19,3.4-2.89S229,23,226.61,23h-2.37v5.26Zm.52,11.12c2.89,0,4.07-1.1,4.07-3.14s-1.18-2.88-4.07-2.88h-2.89v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    className: "cls-1",
    d: "M246.64,23.54h-7.93V17.43h23.17v6.11h-7.94V45h-7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    className: "cls-2",
    d: "M263.62,17.43H274c5.94,0,11,2.21,11,9.17,0,6.72-5.26,9.67-11,9.67h-3.06V45h-7.29Zm10,13.07c2.89,0,4.24-1.44,4.24-3.9s-1.55-3.4-4.24-3.4h-2.72v7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    className: "cls-2",
    d: "M286.54,39c0-4.75,3.74-7.22,13.41-7.73-.24-1.52-1.7-2.2-4.07-2.2-1.79,0-3.57.6-6.12,1.78l-2.54-4.75a20.62,20.62,0,0,1,10.1-2.8c6,0,9.93,3,9.93,9.94V45h-5.94l-.52-2.2h-.17a12.33,12.33,0,0,1-7.21,2.71C289,45.53,286.54,42.47,286.54,39ZM300,38.31V35.59c-5.18.19-6.44,1.36-6.44,2.78,0,1,.76,1.55,2.29,1.55A6.87,6.87,0,0,0,300,38.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    className: "cls-2",
    d: "M310.23,34.4c0-7,5.85-11.12,12.41-11.12a11.75,11.75,0,0,1,8,2.8l-3.29,4.53a7.36,7.36,0,0,0-4.29-1.45,5,5,0,0,0-5.38,4.64c0,.21,0,.42,0,.62a5,5,0,0,0,4.6,5.27,4.86,4.86,0,0,0,.54,0,10,10,0,0,0,5.22-1.78l2.89,4.58a14.3,14.3,0,0,1-8.83,3.06C315.4,45.53,310.23,41.47,310.23,34.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    className: "cls-2",
    d: "M333.65,15.48H341V31.35h.15l6.45-7.55h7.89L341,39.83V45h-7.31ZM342.73,36l4.14-4.5L356,45h-7.87Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xC3\\xADnea_1",
    "data-name": "L\\xC3\\xADnea 1",
    className: "cls-3",
    x1: 194.56,
    x2: 194.56,
    y2: 65.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2-2",
    "data-name": "Capa 2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xC3\\xA1ngulo_11",
    "data-name": "Rect\\xC3\\xA1ngulo 11",
    className: "cls-4",
    y: 6.21,
    width: 55.67,
    height: 56.19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-3",
    "data-name": "Capa 2-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2-2-2",
    "data-name": "Capa 2-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_4-2",
    "data-name": "Capa 4-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xC3\\xA1ngulo_12",
    "data-name": "Rect\\xC3\\xA1ngulo 12",
    className: "cls-5",
    x: 11.77,
    y: 16.08,
    width: 32,
    height: 8.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    className: "cls-5",
    d: "M20.86,38.94v5.33H43.77v8.38h-32V30.56h32v8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    className: "cls-5",
    d: "M66.14,24.88l1.69-.17q.45,2.66,3.72,2.65a4.57,4.57,0,0,0,2.58-.61,1.94,1.94,0,0,0,.9-1.7,1.75,1.75,0,0,0-.66-1.46,5.76,5.76,0,0,0-2.16-.8l-1.62-.33a6.07,6.07,0,0,1-2.9-1.24,2.92,2.92,0,0,1-.9-2.28,3.2,3.2,0,0,1,1.28-2.65,5.66,5.66,0,0,1,3.5-1c3,0,4.65,1.13,5,3.41l-1.6.18a2.27,2.27,0,0,0-1-1.64,4.37,4.37,0,0,0-2.38-.53,3.84,3.84,0,0,0-2.22.54,1.76,1.76,0,0,0-.77,1.53,1.65,1.65,0,0,0,.57,1.38,5.18,5.18,0,0,0,2.08.76l1.61.32a6.37,6.37,0,0,1,3.06,1.29,3,3,0,0,1,.93,2.29,3.43,3.43,0,0,1-1.39,2.91,6.33,6.33,0,0,1-3.85,1Q66.79,28.79,66.14,24.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    className: "cls-5",
    d: "M83,28.72a4.38,4.38,0,0,1-3.35-1.32,4.88,4.88,0,0,1-1.21-3.5,4.6,4.6,0,1,1,9.16-.84,3.93,3.93,0,0,1,0,.84,4.92,4.92,0,0,1-1.21,3.5A4.41,4.41,0,0,1,83,28.72Zm0-1.39a2.68,2.68,0,0,0,2.17-.9,3.94,3.94,0,0,0,.76-2.5,3.84,3.84,0,0,0-.76-2.52,2.65,2.65,0,0,0-2.16-.9,2.7,2.7,0,0,0-2.2.92,4.55,4.55,0,0,0,0,5,2.68,2.68,0,0,0,2.18.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    className: "cls-5",
    d: "M89.79,28.45V15.71h1.66V28.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    className: "cls-5",
    d: "M100.25,19.36h1.63v9.09h-1.52l-.07-1.21a3.33,3.33,0,0,1-2.82,1.46,3.26,3.26,0,0,1-2.38-.87,3.14,3.14,0,0,1-.82-2.35v-6.1h1.65v5.79a2.31,2.31,0,0,0,.5,1.6,1.81,1.81,0,0,0,1.42.56,2.52,2.52,0,0,0,2.44-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    className: "cls-5",
    d: "M105.3,27.36a5.08,5.08,0,0,1-1.15-3.51,5.1,5.1,0,0,1,1.13-3.5,3.92,3.92,0,0,1,3.14-1.27,3.68,3.68,0,0,1,4,3l-1.65.16A2.2,2.2,0,0,0,110,20.9a2.56,2.56,0,0,0-1.61-.45c-1.72,0-2.59,1.13-2.59,3.38a4.05,4.05,0,0,0,.67,2.51,2.54,2.54,0,0,0,4.41-1.15l1.53.16a4.25,4.25,0,0,1-1.35,2.44,4.52,4.52,0,0,1-5.8-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    className: "cls-5",
    d: "M114.56,17.39V15.32h1.66v2.07Zm0,11.06V19.36h1.66v9.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37",
    "data-name": "Trazado 37",
    className: "cls-5",
    d: "M123,28.72a4.4,4.4,0,0,1-3.36-1.32,4.88,4.88,0,0,1-1.21-3.5,4.6,4.6,0,0,1,9.16-.84,5.89,5.89,0,0,1,0,.84,4.92,4.92,0,0,1-1.22,3.51A4.38,4.38,0,0,1,123,28.72Zm0-1.39a2.69,2.69,0,0,0,2.18-.9,4.05,4.05,0,0,0,.73-2.5,3.8,3.8,0,0,0-.77-2.52,3,3,0,0,0-4.23,0l-.08.07A3.83,3.83,0,0,0,120.1,24a3.83,3.83,0,0,0,.76,2.51,2.62,2.62,0,0,0,2.17.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    className: "cls-5",
    d: "M136.66,20a3.06,3.06,0,0,1,.9,2.34v6.1H135.9V22.65a2.27,2.27,0,0,0-.5-1.58A1.78,1.78,0,0,0,134,20.5a2.52,2.52,0,0,0-2.43,1.93v6h-1.67V19.36h1.53l.07,1.22a3.3,3.3,0,0,1,2.79-1.44A3.26,3.26,0,0,1,136.66,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    className: "cls-5",
    d: "M148.62,24.42h-7.15c.12,2,1.09,3,2.9,3A2.68,2.68,0,0,0,147,25.85l1.44.27A3.9,3.9,0,0,1,146.82,28a4.64,4.64,0,0,1-2.54.7,4.19,4.19,0,0,1-3.3-1.35,5,5,0,0,1-1.18-3.47A5.2,5.2,0,0,1,141,20.38a4.12,4.12,0,0,1,3.31-1.27,4,4,0,0,1,3.24,1.32,5.31,5.31,0,0,1,1.12,3.51Zm-6.31-3.34a3.29,3.29,0,0,0-.84,2.11H147c-.15-1.89-1.07-2.83-2.75-2.83A2.55,2.55,0,0,0,142.31,21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40",
    "data-name": "Trazado 40",
    className: "cls-5",
    d: "M150.52,25.87l1.6-.15a2.18,2.18,0,0,0,.82,1.38,3,3,0,0,0,1.75.42c1.53,0,2.24-.5,2.24-1.52a1.14,1.14,0,0,0-.44-.95,3.7,3.7,0,0,0-1.53-.54l-1.23-.22c-1.91-.34-2.86-1.22-2.86-2.64a2.27,2.27,0,0,1,.95-2,4.52,4.52,0,0,1,2.7-.69c2.28,0,3.64.9,4,2.69l-1.52.19c-.25-1.1-1.06-1.64-2.44-1.64s-2.08.44-2.08,1.34a1,1,0,0,0,.45.9,3.94,3.94,0,0,0,1.45.48l1.14.2a4.53,4.53,0,0,1,2.29.92,2.29,2.29,0,0,1,.76,1.8,2.54,2.54,0,0,1-1,2.15,4.7,4.7,0,0,1-2.87.77C152.34,28.79,150.94,27.82,150.52,25.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    className: "cls-5",
    d: "M75.28,35.61V37h-4V48.36h-1.7V37h-4V35.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    className: "cls-5",
    d: "M83.1,44.28H76c.12,2,1.09,3,2.9,3a2.69,2.69,0,0,0,2.59-1.52l1.44.26a4,4,0,0,1-1.58,1.9,4.79,4.79,0,0,1-2.53.66,4.2,4.2,0,0,1-3.31-1.22,5,5,0,0,1-1.17-3.47,5.07,5.07,0,0,1,1.17-3.5A4.08,4.08,0,0,1,78.75,39,4,4,0,0,1,82,40.36a5.17,5.17,0,0,1,1.1,3.49ZM76.82,41a3.27,3.27,0,0,0-.84,2.1H81.5c-.15-1.89-1.07-2.83-2.75-2.83a2.54,2.54,0,0,0-1.93.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    className: "cls-5",
    d: "M86,47.27a5.11,5.11,0,0,1-1.15-3.5,5.12,5.12,0,0,1,1.12-3.51A4,4,0,0,1,89.07,39a3.69,3.69,0,0,1,4,3l-1.65.16a2.2,2.2,0,0,0-.76-1.31,2.58,2.58,0,0,0-1.61-.45c-1.73,0-2.59,1.12-2.59,3.38a4.05,4.05,0,0,0,.67,2.51,2.55,2.55,0,0,0,4.41-1.18l1.56.16a4.15,4.15,0,0,1-1.38,2.46,4,4,0,0,1-2.61.84A4,4,0,0,1,86,47.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    className: "cls-5",
    d: "M102.05,39.89a3.14,3.14,0,0,1,.9,2.34v6.1h-1.67V42.57a2.26,2.26,0,0,0-.5-1.58,1.85,1.85,0,0,0-1.42-.58,2.53,2.53,0,0,0-2.44,1.92v6H95.26V39.26h1.53l.07,1.21A3.32,3.32,0,0,1,99.68,39,3.27,3.27,0,0,1,102.05,39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    className: "cls-5",
    d: "M109.77,48.62a4.36,4.36,0,0,1-3.36-1.3,4.9,4.9,0,0,1-1.21-3.49,4.6,4.6,0,1,1,9.17-.77,5,5,0,0,1,0,.77,4.86,4.86,0,0,1-1.22,3.49A4.32,4.32,0,0,1,109.77,48.62Zm0-1.39a2.69,2.69,0,0,0,2.18-.9,4,4,0,0,0,.73-2.51,3.8,3.8,0,0,0-.77-2.52,2.65,2.65,0,0,0-2.16-.9,2.68,2.68,0,0,0-2.17.9,3.84,3.84,0,0,0-.76,2.52,3.91,3.91,0,0,0,.76,2.49,2.72,2.72,0,0,0,2.19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    className: "cls-5",
    d: "M116.55,48.35V35.62h1.66V48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    className: "cls-5",
    d: "M125,48.62a4.34,4.34,0,0,1-3.35-1.3,4.83,4.83,0,0,1-1.22-3.52,4.93,4.93,0,0,1,1.2-3.5,4.59,4.59,0,0,1,7.94,3.5,4.91,4.91,0,0,1-1.19,3.52A4.33,4.33,0,0,1,125,48.62Zm0-1.39a2.68,2.68,0,0,0,2.17-.9,4,4,0,0,0,.75-2.51,3.82,3.82,0,0,0-.75-2.51,3,3,0,0,0-4.31,0h0a4.52,4.52,0,0,0,0,5,2.67,2.67,0,0,0,2.14.88ZM124,37.48l1.85-2.81h2l-2.4,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    className: "cls-5",
    d: "M138.38,39.25h1.45v8.89a3.59,3.59,0,0,1-1.07,2.77,4.3,4.3,0,0,1-3,1c-2.25,0-3.6-.9-4-2.73l1.59-.15a2.28,2.28,0,0,0,2.53,1.64,2.14,2.14,0,0,0,2.38-1.86,2.33,2.33,0,0,0,0-.59V46.68a3.67,3.67,0,0,1-2.82,1.12,3.73,3.73,0,0,1-2.88-1.23,4.46,4.46,0,0,1-1.13-3.17,4.7,4.7,0,0,1,1.07-3.22,3.78,3.78,0,0,1,3-1.23,3.61,3.61,0,0,1,2.93,1.35Zm-.19,5.22V42.23a2.54,2.54,0,0,0-2.6-1.92,2.36,2.36,0,0,0-1.93.82,4.09,4.09,0,0,0,0,4.57,2.36,2.36,0,0,0,1.93.83A2.5,2.5,0,0,0,138.19,44.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    className: "cls-5",
    d: "M142.94,37.29v-2h1.65v2Zm0,11.06V39.26h1.65v9.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    className: "cls-5",
    d: "M147.88,47.27a5,5,0,0,1-1.14-3.5,5.12,5.12,0,0,1,1.12-3.51A4,4,0,0,1,151,39a3.69,3.69,0,0,1,4,3l-1.64.16a2.2,2.2,0,0,0-.76-1.31,2.58,2.58,0,0,0-1.61-.45c-1.73,0-2.59,1.12-2.58,3.38a4,4,0,0,0,.67,2.51,2.55,2.55,0,0,0,3.59.25,2.5,2.5,0,0,0,.82-1.43l1.57.16a4.25,4.25,0,0,1-1.37,2.44,4.54,4.54,0,0,1-5.83-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    "data-name": "Trazado 51",
    className: "cls-5",
    d: "M165.89,47v1.35h-1.35a1.64,1.64,0,0,1-1.07-.35,1.42,1.42,0,0,1-.5-1,3.56,3.56,0,0,1-3.24,1.53,3.72,3.72,0,0,1-2.35-.7,2.37,2.37,0,0,1-.9-1.95,2.22,2.22,0,0,1,.86-1.88,6.15,6.15,0,0,1,2.6-1l2.11-.4a2.57,2.57,0,0,0,.76-.23V42a1.58,1.58,0,0,0-.45-1.27,2.51,2.51,0,0,0-1.6-.4,3,3,0,0,0-1.8.4,1.87,1.87,0,0,0-.64,1.37l-1.53-.2c.22-1.92,1.53-2.89,4-2.89a4.3,4.3,0,0,1,2.78.77,2.76,2.76,0,0,1,.83,2.16v4.34a.63.63,0,0,0,.45.77.81.81,0,0,0,.31,0Zm-4.08-.12a2.49,2.49,0,0,0,1-1.39V43.66a6.52,6.52,0,0,1-.63.18l-2,.4a3.56,3.56,0,0,0-1.53.6,1.25,1.25,0,0,0-.49,1.06,1.34,1.34,0,0,0,.5,1.1,2.22,2.22,0,0,0,1.41.4,3.08,3.08,0,0,0,1.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    "data-name": "Trazado 52",
    className: "cls-5",
    d: "M166.92,45.81l1.59-.17a2.25,2.25,0,0,0,.82,1.4,3.11,3.11,0,0,0,1.76.42c1.5,0,2.25-.51,2.24-1.53a1.12,1.12,0,0,0-.44-.94,3.49,3.49,0,0,0-1.53-.55l-1.22-.23c-1.91-.35-2.86-1.23-2.86-2.65a2.26,2.26,0,0,1,.95-2,4.55,4.55,0,0,1,2.69-.7q3.45,0,4,2.7l-1.52.18c-.24-1.09-1-1.63-2.43-1.63s-2.08.45-2.09,1.35a1,1,0,0,0,.45.85,3.86,3.86,0,0,0,1.46.51l1.15.2a4.46,4.46,0,0,1,2.28.93,2.32,2.32,0,0,1,.77,1.8,2.55,2.55,0,0,1-1,2.14,4.7,4.7,0,0,1-2.87.77Q167.56,48.7,166.92,45.81Z"
  })))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEcoforBtpack);
export default __webpack_public_path__ + "static/media/logo-ecofor-btpack.791b22d70649b00da001f2e0876db237.svg";
export { ForwardRef as ReactComponent };